import * as moment from "moment";
import * as classNames from "classnames";
import { IKeyValueLog } from "motw_core/Entity/IKeyValueLog";
import { integratedPlusEmotionCharacter } from "motw_core/Repositories/EmotionRepository";
import * as React from "react";
import { maxItemsToDisplay } from "source/app/presentation/MainPanel/KeyValueLogs/KeyValueLogs";
import { Style, StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function DisplayKVBlock({
    color,
    numItems,
    index,
    isLowerBlock,
    isSpecialBlock,
    isFirstBlockOfDay,
    topOffsetIndex,
    keyValueLog,
}: {
    color: string;
    numItems: number;
    index: number;
    isLowerBlock: boolean;
    isSpecialBlock: boolean;
    isFirstBlockOfDay: boolean;
    topOffsetIndex: number;
    keyValueLog: IKeyValueLog;
}) {
    const defaultOpacity = 0.9;
    const shouldReduceOpacity = numItems >= maxItemsToDisplay && index < 10;
    const opacity = shouldReduceOpacity ? index * 0.1 : defaultOpacity;
    const isIntegratedBlock = color.toLowerCase() === "#ffffff";
    const isIntegratedPlusBlock =
        keyValueLog.value === integratedPlusEmotionCharacter;

    const lowerKVBlockStyleClass = StyleClass(`kvBlock_Lower`, {
        zIndex: 0,
    });

    const normalKVBlockStyleClass = StyleClass(`kvBlock_Normal`, {
        filter: `drop-shadow(1px 3px 4px rgba(73, 73, 73, 0.7))`,
        zIndex: 1,
    });

    const specialKVBlockStyleClass = StyleClass(`kvBlock_Special`, {
        filter: `drop-shadow(0 0 2px rgba(255, 255, 255, 0.22)) drop-shadow(0 2px 3px black)`,
        zIndex: 2,
    });

    const integratedKVBlockStyleClass = StyleClass(`kvBlock_Integrated`, {
        filter: `drop-shadow(0 0 2px rgba(255, 255, 255, 0.95)) drop-shadow(0 0 6px rgba(255, 218, 145, 0.72)) drop-shadow(0 2px 3px black)`,
        zIndex: 2,
    });

    const integratedPlusKVBlockStyleClass = StyleClass(
        `kvBlock_IntegratedPlus`,
        {
            filter: `drop-shadow(0 0 2px rgba(255, 255, 255, 1)) drop-shadow(0 0 7px rgba(255, 206, 104, 0.92)) drop-shadow(0 2px 3px black)`,
            zIndex: 3,
        }
    );

    const kvBlockGlyphStyleClass = StyleClass(`kvBlock_Glyph`, {
        backgroundColor: `currentColor`,
        backgroundImage: isIntegratedPlusBlock
            ? `repeating-linear-gradient(135deg, #fffdf0 0 2px, #c89032 2px 4px)`
            : undefined,
        boxShadow: `inset 0 1px 0 rgba(255, 255, 255, 0.45), inset 0 -1px 0 rgba(0, 0, 0, 0.35)`,
        clipPath: `polygon(2px 0, calc(100% - 2px) 0, 100% 2px, 100% calc(100% - 2px), calc(100% - 2px) 100%, 2px 100%, 0 calc(100% - 2px), 0 2px)`,
        display: `inline-block`,
        height: `10px`,
        margin: `0 1px`,
        verticalAlign: `middle`,
        width: `7px`,
    });

    const firstBlockOfDayStyleClass = StyleClass(`kvBlock_FirstBlockOfDay`, {
        borderLeft: `7px solid transparent`,
    });

    const tooltip = moment(keyValueLog.lastmodifiedtime).format(
        "YYYY-MM-DD HH:mm"
    );

    return (
        <span
            data-tip={tooltip}
            {...Style(`kvLogItem_${color}_${opacity}_${topOffsetIndex}`, {
                color,
                opacity,
                position: "relative",
                top: `${-2 * topOffsetIndex}px`,
            })}
            className={classNames({
                [normalKVBlockStyleClass]: !isSpecialBlock && !isLowerBlock,
                [specialKVBlockStyleClass]:
                    isSpecialBlock && !isIntegratedBlock && !isIntegratedPlusBlock,
                [integratedKVBlockStyleClass]:
                    isIntegratedBlock && !isIntegratedPlusBlock,
                [integratedPlusKVBlockStyleClass]: isIntegratedPlusBlock,
                [lowerKVBlockStyleClass]: isLowerBlock,
                [firstBlockOfDayStyleClass]: isFirstBlockOfDay,
            })}
        >
            <span className={kvBlockGlyphStyleClass} />
        </span>
    );
}
